import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
require('../webapp/_assets/styles/main.scss')

Vue.config.productionTip = false

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
